// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const ChecklistIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
      <path
        d="M17.35 3.68c-.13-.04-.26.06-.28.2-.2 1.3-1.32 2.3-2.68 2.3H9.61c-1.36 0-2.5-1-2.69-2.3-.02-.14-.15-.24-.28-.2-1.91.57-3.3 2.35-3.3 4.45v9.73c0 2.55 2.07 4.64 4.64 4.64h8.04c2.57 0 4.64-2.09 4.64-4.64V8.13c0-2.1-1.39-3.89-3.31-4.45"
        opacity=".5"
      />
      <path d="M9.6 4.88h4.8c.74 0 1.35-.6 1.37-1.34l.01-.06v-.6c0-.76-.62-1.38-1.39-1.38H9.61c-.77 0-1.4.62-1.4 1.39v.59l.01.05c.02.76.64 1.35 1.39 1.35m6.2 7.61-4.33 4.34q-.25.23-.58.24-.34 0-.58-.24L8.19 14.7c-.32-.32-.32-.84 0-1.16s.84-.32 1.16 0l1.55 1.54 3.76-3.76c.31-.31.84-.31 1.15 0 .32.32.32.84 0 1.16" />
    </g>
  </SvgIcon>
);

export default ChecklistIcon;
